import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom";
import {
  daysAvailableState,
  isChangeFormSearchState,
} from "src/SearchHours/state/atoms";
import {
  capitalizeWords,
  finderSpecialityByName,
} from "src/shared/global/helpers";
import { dayDefaultAvailableState } from "src/SearchHours/components/calendars/state/atoms";
import {
  disabledSelectState,
  errorsWaitListState,
  professionalWaitListState,
  specialitiesWaitListState,
  specialityWaitListState,
} from "../state/atoms";
import { ServiceWaitList } from "src/services/agenda/waitlist";
import AutocompleteSkeleton from "src/shared/components/skeletons/AutocompleteSkeleton";

const AutocompleteSpecialities = ({ size = "small", styles }) => {
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const [specialities, setSpecialities] = useRecoilState(
    specialitiesWaitListState
  );

  const [specialitySelected, setSpecialitySelected] = useRecoilState(
    specialityWaitListState
  );

  const [professionalSelected, setProfessionalSelected] = useRecoilState(
    professionalWaitListState
  );

  const [errorsWaitList, setErrorsWaitList] =
    useRecoilState(errorsWaitListState);

  const [disableSelect, setDisabledSelect] =
    useRecoilState(disabledSelectState);

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-especialidad"
        text="Especialidad"
        style={{ ...styles.label }}
      />
      <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-especialidad"
        options={specialities.map((option) => `${option.espNombre}`)}
        getOptionLabel={(option) => capitalizeWords(option) || null}
        value={specialitySelected.value || null}
        noOptionsText="Sin resultados"
        disabled={disableSelect}
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          if (reason === "clear") {
            setSpecialitySelected({
              value: "",
              code: null,
            });

            setProfessionalSelected({
              value: "",
              code: null,
            });

            return;
          }

          if (reason === "selectOption") {
            const findSpeciality = finderSpecialityByName(specialities, value);
            console.log("findSpeciality", findSpeciality);

            setSpecialitySelected({
              value: value,
              code: findSpeciality?.espCodigo || findSpeciality?.esCodigo,
            });

            setProfessionalSelected({
              value: "",
              code: null,
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Buscar"
            variant="outlined"
            error={errorsWaitList.speciality.length > 0}
            helperText={errorsWaitList.speciality}
          />
        )}
      />
    </>
  );
};

export default AutocompleteSpecialities;
